<template>
  <div id="loan-list">
    <section :class="['amount', isUseingLimit ? 'is-useing-limit' : '']">
      <div class="amount-item">
        <span class="amount-title">已还款金额</span>
        <!-- <span class="amount-title-en">Repayment amount</span> -->
        <span class="amount-money"><em>￥</em>{{myLoanData.recedSum}}</span>
      </div>
      <div class="amount-item">
        <span class="amount-title">未还款金额</span>
        <!-- <span class="amount-title-en">Outstanding amount</span> -->
        <span class="amount-money"><em>￥</em>{{myLoanData.balancedSum}}</span>
      </div>
      <div v-if="isUseingLimit" class="amount-item">
        <span class="amount-title">可用额度</span>
        <!-- <span class="amount-title-en">Available credit</span> -->
        <span class="amount-money"><em>￥</em>{{myLoanData.availableQuota | addThousandSign(2)}}</span>
      </div>
      <div v-if="isUseingLimit" class="amount-item">
        <span class="amount-title">总额度</span>
        <!-- <span class="amount-title-en">Total lines</span> -->
        <span class="amount-money"><em>￥</em>{{myLoanData.totalQuota | addThousandSign(2)}}</span>
      </div>
    </section>
    <section class="info-card">
      <div class="info-card-item">
        <span class="info-card-item-ch">已还本金</span>
        <span class="info-card-item-num" :title="myLoanData.recedPrincipal">￥{{myLoanData.recedPrincipal}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-card-item">
        <span class="info-card-item-ch">已还利息</span>
        <span class="info-card-item-num" :title="myLoanData.recedInterest">￥{{myLoanData.recedInterest}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-card-item">
        <span class="info-card-item-ch">已还咨询费</span>
        <span class="info-card-item-num" :title="myLoanData.recedConsulting">￥{{myLoanData.recedConsulting}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-card-item">
        <span class="info-card-item-ch">已还罚息</span>
        <span class="info-card-item-num" :title="myLoanData.recedPunish">￥{{myLoanData.recedPunish}}</span>
      </div>
    </section>
    <section class="info-card" style="margin-top:0px;">
      <div class="info-card-item">
        <span class="info-card-item-ch">未还本金</span>
        <span class="info-card-item-num" :title="myLoanData.balancedPrincipal">￥{{myLoanData.balancedPrincipal}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-card-item">
        <span class="info-card-item-ch">未还利息</span>
        <span class="info-card-item-num" :title="myLoanData.balancedInterest">￥{{myLoanData.balancedInterest}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-card-item">
        <span class="info-card-item-ch">未还咨询费</span>
        <span class="info-card-item-num" :title="myLoanData.balancedConsulting">￥{{myLoanData.balancedConsulting}}</span>
        <i class="vertical-line"></i>
      </div>
      <div class="info-card-item">
        <span class="info-card-item-ch">未还罚息</span>
        <span class="info-card-item-num" :title="myLoanData.balancedPunish">￥{{myLoanData.balancedPunish}}</span>
      </div>
    </section>
    <section class="loan-lists">
      <el-tabs :active-name="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="item in labelName" :label="item.label" :name="item.name" :frontApplyState="item.name"
                     :key="item.name"></el-tab-pane>
      </el-tabs>
      <router-view></router-view>
    </section>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import * as types from '../../vuex/types';

  export default {
    data () {
      return {
        labelName: [{
          label: '全部',
          name: '0'
        }, {
          label: '审批中',
          name: '2'
        }, {
          label: '审批通过',
          name: '3'
        }, {
          label: '审批不通过',
          name: '4'
        }, {
          label: '已放款',
          name: '32'
        }, {
          label: '已结清',
          name: '33'
        }, {
          label: '未提交',
          name: '1'
        }]
      };
    },
    computed: {
      ...mapGetters({
        activeName: types.ACTIVE_NAME,
        userInfo: types.GET_USER,
        myLoanData: types.MY_LOAN_DATA,
        frontApplyState: types.FRONT_APPLY_STATE,
        isUseingLimit: types.IS_USEING_LIMIT
      })
    },
    methods: {
      ...mapMutations({
        setFrontApplyState: types.SET_FRONT_APPLY_STATE,
        setActiveName: types.SET_ACTIVE_NAME
      }),
      ...mapActions({
        getMyloanData: types.GET_MY_LOAN_DATA
      }),
      handleClick (tab) {
        this.setActiveName(tab.name);
        this.setFrontApplyState(tab.name);
        this.$router.push({
          path: '/personalCenter/myLoan/loanLists',
          query: {frontApplyState: this.frontApplyState, pageCount: 1}
        });
      }
    },
    mounted () {
      this.getMyloanData({
        token: this.userInfo.token,
        frontApplyState: 0,
        pageCurrent: 1
      });
      this.$router.push({
        path: '/personalCenter/myLoan/loanLists',
        query: {frontApplyState: 0, pageCount: 1}
      });
    }
  };
</script>
<style lang='scss'>
  #loan-list {
    position: relative;
    left: 20px;
  }

  .amount {
    overflow: hidden;
    .amount-item{
      display: inline-block;
      height: 187px;
      width: 437px;
      overflow: hidden;
      margin-left: 11px;
      background:#fff url('../../../static/images/Columns.png') no-repeat center 126px;

      &:first-child{
         margin-left: 0;
       }

      .amount-title {
        margin-top: 40px;
        font-size: 18px;
        color: #35c4f9;
        font-family: 'FZLanTingHei-DB-GBK';
      }

      .amount-title-en {
        margin-top: 7px;
        font-size: 13px;
        color: #3e454d;
        font-family: 'MyriadPro-Regular';
      }

      .amount-money {
        margin-top: 10px;
        font-size: 25px;
        font-weight: bold;
        color: #34495e;
        font-family: 'MyriadPro-Bold';

        em{
          font-style: normal;
          // font-size: 26px;
          font-family: 'Microsoft YaHei'
        }
      }
    }

    span {
      display: block;
      width: 100%;
      text-align: center;
    }
  }

  // 还没有贷款额度
  .amount.is-useing-limit{
    .amount-item{
      width: 207px;
      margin-left:15px;
      background:#fff url('../../../static/images/Columns.png') no-repeat center 144px;

      &:first-child{
         margin-left:0;
       }

      .ask-amount-btn {
        width:92px;
        height:30px;
        display: block;
        margin:15px auto;
        border-radius: 2px;
        cursor: pointer;
        background: $orange;
        line-height: 30px;
        font-size: 14px;
        color: $white;
        font-family: "FZLanTingHei-B", "Microsoft YaHei";
      }
    }
  }

  .amount,
  .info-card,
  .loan-lists {
    position: relative;
    margin-top: 20px;
    width: 100%;
  }

  .info-card,
  .repayment-amount,
  .outstanding-amount,
  .loan-lists {
    border-radius: 2px;
    background: #fff;
  }

  .loan-lists {
    margin-bottom: 20px;
  }










  //info-card块css
  .info-card {
    height: 68px;
    line-height: 68px;
  }

  .info-card-item {
    float: left;
    margin: auto;
    width: 25%;
    vertical-align: middle;
    position: relative;
  }

  .info-card-item-ch {
    margin-left: 30px;
    font-family: 'FZLanTingHei-DB-GBK';
    text-align: center;
    font-size: 14px;
    color: #3e454d;
  }

  .info-card-item-num {
    width: 90px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 10px;
    /*max-width: 90px;*/
    font-family: 'Microsoft YaHei';
    font-size: 14px;
    color: #35c4f9;
    position: absolute;
    overflow: hidden;
  }

  .vertical-line {
    float: right;
    margin-top: 18px;
    width: 1px;
    height: 33px;
    border-right: 1px solid #e8e8e8;
  }

  //loan-lists块css
  //覆盖饿了么UI样式
  #loan-list {
    .el-tabs__item {
      padding: 0 30px;
      font-size: 16px;
      /*padding:0;*/
      /*margin:0 30px;*/
      /*display: inline-block;*/
      color: #34495e;
      font-family: 'FZLanTingHei-DB-GBK';
    }

    /*.el-tabs__item.is-active{*/
    /*border-bottom:2px solid #35c4f9;*/
    /*}*/

    .el-tabs__header {
      border-bottom: none;
    }

    .is-active {
      color: #35c4f9;
    }

    .el-tabs__active-bar {
      /*display: none;*/
      background-color: #35c4f9;
    }

    .el-tabs__active-bar {
      bottom: 3px;
      height: 0.1em;
    }
  }
</style>
<!--<template>-->
  <!--<div id="loan-list">-->
    <!--<section :class="['amount', isUseingLimit ? 'is-useing-limit' : '']">-->
      <!--<div class="amount-item">-->
        <!--<span class="amount-title">已还款金额</span>-->
        <!--<span class="amount-title-en">Repayment amount</span>-->
        <!--<span class="amount-money"><em>￥</em>{{myLoanData.recedSum}}</span>-->
      <!--</div>-->
      <!--<div class="amount-item">-->
        <!--<span class="amount-title">未还款金额</span>-->
        <!--<span class="amount-title-en">Outstanding amount</span>-->
        <!--<span class="amount-money"><em>￥</em>{{myLoanData.balancedSum}}</span>-->
      <!--</div>-->
      <!--<div v-if="isUseingLimit" class="amount-item">-->
        <!--<span class="amount-title">可用额度</span>-->
        <!--<span class="amount-title-en">Available credit</span>-->
        <!--<span class="amount-money"><em>￥</em>{{myLoanData.availableQuota | addThousandSign(2)}}</span>-->
      <!--</div>-->
      <!--<div v-if="isUseingLimit" class="amount-item">-->
        <!--<span class="amount-title">总额度</span>-->
        <!--<span class="amount-title-en">Total lines</span>-->
        <!--<span class="amount-money"><em>￥</em>{{myLoanData.totalQuota | addThousandSign(2)}}</span>-->
      <!--</div>-->
    <!--</section>-->
    <!--<section class="info-card">-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">已还本金</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.recedPrincipal}}</span>-->
        <!--<i class="vertical-line"></i>-->
      <!--</div>-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">已还利息</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.recedInterest}}</span>-->
        <!--<i class="vertical-line"></i>-->
      <!--</div>-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">已还咨询费</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.recedConsulting}}</span>-->
        <!--<i class="vertical-line"></i>-->
      <!--</div>-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">已还罚息</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.recedPunish}}</span>-->
        <!--<i class="vertical-line"></i>-->
      <!--</div>-->
    <!--</section>-->
    <!--<section class="info-card" style="margin-top:0px;">-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">未还本金</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.balancedPrincipal}}</span>-->
        <!--<i class="vertical-line"></i>-->
      <!--</div>-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">未还利息</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.balancedInterest}}</span>-->
      <!--</div>-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">未还咨询费</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.balancedConsulting}}</span>-->
        <!--<i class="vertical-line"></i>-->
      <!--</div>-->
      <!--<div class="info-card-item">-->
        <!--<span class="info-card-item-ch">未还罚息</span>-->
        <!--<span class="info-card-item-num">￥{{myLoanData.balancedPunish}}</span>-->
      <!--</div>-->
    <!--</section>-->
    <!--<section class="loan-lists">-->
      <!--<el-tabs :active-name="activeName" @tab-click="handleClick">-->
        <!--<el-tab-pane v-for="item in labelName" :label="item.label" :name="item.name" :frontApplyState="item.name"-->
                     <!--:key="item.name"></el-tab-pane>-->
      <!--</el-tabs>-->
      <!--<router-view></router-view>-->
    <!--</section>-->
  <!--</div>-->
<!--</template>-->
<!--<script>-->
  <!--import { mapGetters, mapActions, mapMutations } from 'vuex'-->
  <!--import * as types from '../../vuex/types'-->

  <!--export default {-->
    <!--data () {-->
      <!--return {-->
        <!--labelName: [{-->
          <!--label: '全部',-->
          <!--name: '0'-->
        <!--}, {-->
          <!--label: '审批中',-->
          <!--name: '2'-->
        <!--}, {-->
          <!--label: '审批通过',-->
          <!--name: '3'-->
        <!--}, {-->
          <!--label: '审批不通过',-->
          <!--name: '4'-->
        <!--}, {-->
          <!--label: '已放款',-->
          <!--name: '32'-->
        <!--}, {-->
          <!--label: '已结清',-->
          <!--name: '33'-->
        <!--}, {-->
          <!--label: '未提交',-->
          <!--name: '1'-->
        <!--}]-->
      <!--}-->
    <!--},-->
    <!--computed: {-->
      <!--...mapGetters({-->
        <!--activeName: types.ACTIVE_NAME,-->
        <!--userInfo: types.GET_USER,-->
        <!--myLoanData: types.MY_LOAN_DATA,-->
        <!--frontApplyState: types.FRONT_APPLY_STATE,-->
        <!--isUseingLimit: types.IS_USEING_LIMIT-->
      <!--})-->
    <!--},-->
    <!--methods: {-->
      <!--...mapMutations({-->
        <!--setFrontApplyState: types.SET_FRONT_APPLY_STATE,-->
        <!--setActiveName: types.SET_ACTIVE_NAME-->
      <!--}),-->
      <!--...mapActions({-->
        <!--getMyloanData: types.GET_MY_LOAN_DATA-->
      <!--}),-->
      <!--handleClick (tab) {-->
        <!--this.setActiveName(tab.name)-->
        <!--this.setFrontApplyState(tab.name)-->
        <!--this.$router.push({-->
          <!--path: '/personalCenter/myLoan/loanLists',-->
          <!--query: {frontApplyState: this.frontApplyState, pageCount: 1}-->
        <!--})-->
      <!--}-->
    <!--},-->
    <!--mounted () {-->
      <!--this.getMyloanData({-->
        <!--token: this.userInfo.token,-->
        <!--frontApplyState: 0,-->
        <!--pageCurrent: 1-->
      <!--})-->
      <!--this.$router.push({-->
        <!--path: '/personalCenter/myLoan/loanLists',-->
        <!--query: {frontApplyState: 0, pageCount: 1}-->
      <!--})-->
    <!--}-->
  <!--}-->
<!--</script>-->
<!--<style lang='scss'>-->
  <!--#loan-list {-->
    <!--position: relative;-->
    <!--left: 20px;-->
  <!--}-->

  <!--.amount {-->
    <!--overflow: hidden;-->
    <!--.amount-item{-->
      <!--display: inline-block;-->
      <!--height: 187px;-->
      <!--width: 437px;-->
      <!--overflow: hidden;-->
      <!--margin-left: 11px;-->
      <!--background:#fff url('../../../static/images/amount_bg.png') no-repeat center 126px;-->

      <!--&:first-child{-->
         <!--margin-left: 0;-->
       <!--}-->

      <!--.amount-title {-->
        <!--margin-top: 40px;-->
        <!--font-size: 18px;-->
        <!--color: #35c4f9;-->
        <!--font-family: 'FZLanTingHei-DB-GBK';-->
      <!--}-->

      <!--.amount-title-en {-->
        <!--margin-top: 7px;-->
        <!--font-size: 13px;-->
        <!--color: #3e454d;-->
        <!--font-family: 'MyriadPro-Regular';-->
      <!--}-->

      <!--.amount-money {-->
        <!--margin-top: 10px;-->
        <!--font-size: 25px;-->
        <!--font-weight: bold;-->
        <!--color: #34495e;-->
        <!--font-family: 'MyriadPro-Bold';-->

        <!--em{-->
          <!--font-style: normal;-->
          <!--font-size: 26px;-->
          <!--font-family: 'Microsoft YaHei'-->
        <!--}-->
      <!--}-->
    <!--}-->

    <!--span {-->
      <!--display: block;-->
      <!--width: 100%;-->
      <!--text-align: center;-->
    <!--}-->
  <!--}-->

  <!--// 还没有贷款额度-->
  <!--.amount.is-useing-limit{-->
    <!--.amount-item{-->
      <!--width: 207px;-->
      <!--margin-left:15px;-->
      <!--background:#fff url('../../../static/images/amount_bg2.png') no-repeat center 144px;-->

      <!--&:first-child{-->
         <!--margin-left:0;-->
       <!--}-->

      <!--.ask-amount-btn {-->
        <!--width:92px;-->
        <!--height:30px;-->
        <!--display: block;-->
        <!--margin:15px auto;-->
        <!--border-radius: 2px;-->
        <!--cursor: pointer;-->
        <!--background: $orange;-->
        <!--line-height: 30px;-->
        <!--font-size: 14px;-->
        <!--color: $white;-->
        <!--font-family: "FZLanTingHei-B", "Microsoft YaHei";-->
      <!--}-->
    <!--}-->
  <!--}-->

  <!--.amount,-->
  <!--.info-card,-->
  <!--.loan-lists {-->
    <!--position: relative;-->
    <!--margin-top: 20px;-->
    <!--width: 100%;-->
  <!--}-->

  <!--.info-card,-->
  <!--.repayment-amount,-->
  <!--.outstanding-amount,-->
  <!--.loan-lists {-->
    <!--border-radius: 2px;-->
    <!--background: #fff;-->
  <!--}-->

  <!--.loan-lists {-->
    <!--margin-bottom: 20px;-->
  <!--}-->










  <!--//info-card块css-->
  <!--.info-card {-->
    <!--height: 68px;-->
    <!--line-height: 68px;-->
  <!--}-->

  <!--.info-card-item {-->
    <!--float: left;-->
    <!--margin: auto;-->
    <!--width: 25%;-->
    <!--vertical-align: middle;-->
  <!--}-->

  <!--.info-card-item-ch {-->
    <!--margin-left: 30px;-->
    <!--font-family: 'FZLanTingHei-DB-GBK';-->
    <!--text-align: center;-->
    <!--font-size: 14px;-->
    <!--color: #3e454d;-->
  <!--}-->

  <!--.info-card-item-num {-->
    <!--padding-left: 10px;-->
    <!--max-width: 90px;-->
    <!--font-family: 'Microsoft YaHei';-->
    <!--font-size: 14px;-->
    <!--color: #35c4f9;-->
  <!--}-->

  <!--.vertical-line {-->
    <!--float: right;-->
    <!--margin-top: 18px;-->
    <!--width: 1px;-->
    <!--height: 33px;-->
    <!--border-right: 1px solid #e8e8e8;-->
  <!--}-->

  <!--//loan-lists块css-->
  <!--//覆盖饿了么UI样式-->
  <!--#loan-list {-->
    <!--.el-tabs__item {-->
      <!--padding: 0 30px;-->
      <!--font-size: 16px;-->
      <!--/*padding:0;*/-->
      <!--/*margin:0 30px;*/-->
      <!--/*display: inline-block;*/-->
      <!--color: #34495e;-->
      <!--font-family: 'FZLanTingHei-DB-GBK';-->
    <!--}-->

    <!--/*.el-tabs__item.is-active{*/-->
    <!--/*border-bottom:2px solid #35c4f9;*/-->
    <!--/*}*/-->

    <!--.el-tabs__header {-->
      <!--border-bottom: none;-->
    <!--}-->

    <!--.is-active {-->
      <!--color: #35c4f9;-->
    <!--}-->

    <!--.el-tabs__active-bar {-->
      <!--/*display: none;*/-->
      <!--background-color: #35c4f9;-->
    <!--}-->

    <!--.el-tabs__active-bar {-->
      <!--bottom: 3px;-->
      <!--height: 0.1em;-->
    <!--}-->
  <!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// MyLoan.vue?03910819